import DOMPurify from 'dompurify';

export const sanitize = (html) => {
  return { __html: DOMPurify.sanitize(html) };
};

export const sanitizeHtml = (html) => {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['style'] });
};
